// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Brand/index.css
// module id = 1885
// module chunks = 0